import React, { useEffect, useState } from 'react';
import { Container, Typography, Card, CardContent, Link } from '@mui/material';
import bibtexParse from 'bibtex-parse-js';
import { formatAuthors } from '../utils';

function Other() {
    const [others, setOthers] = useState([]);

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/others.bib`)
            .then((response) => response.text())
            .then((data) => {
                const parsed = bibtexParse.toJSON(data);
                setOthers(parsed);
            })
            .catch((error) => console.error('Error loading BibTeX file:', error));
    }, []);

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                Other Contributions
            </Typography>
            {others.map((other, index) => (
                <Card
                    key={index}
                    variant="outlined"
                    sx={{
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'flex-start',
                        padding: '10px',
                    }}
                >
                    <CardContent sx={{ flex: 1 }}>
                        {/* タイトル */}
                        <Typography variant="body1" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>
                            {other.entryTags.title}
                        </Typography>

                        {/* 著者情報 */}
                        {other.entryTags.author && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                {formatAuthors(other.entryTags.author)}
                            </Typography>
                        )}

                        {/* タイプごとの情報 */}
                        {other.entryType === 'misc' && other.entryTags.howpublished === 'Invited Talk' && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                Invited Talk: {other.entryTags.eventtitle}
                                {other.entryTags.location && `, ${other.entryTags.location}`}
                                {other.entryTags.year && `, ${other.entryTags.year}`}
                            </Typography>
                        )}
                        {other.entryType === 'article' && other.entryTags.note === 'Invited Article' && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                Invited Article in: {other.entryTags.journal || other.entryTags.booktitle}
                                {other.entryTags.volume && `, Vol. ${other.entryTags.volume}`}
                                {other.entryTags.pages && `, pp. ${other.entryTags.pages}`}
                                {other.entryTags.year && `, ${other.entryTags.year}`}
                            </Typography>
                        )}
                        {other.entryType === 'misc' && other.entryTags.howpublished === 'Unrefereed' && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                {other.entryTags.note}
                                {other.entryTags.year && `, ${other.entryTags.year}`}
                            </Typography>
                        )}

                        {/* DOI */}
                        {other.entryTags.doi && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                DOI: <Link href={`https://doi.org/${other.entryTags.doi}`} target="_blank" rel="noopener noreferrer">
                                    {other.entryTags.doi}
                                </Link>
                            </Typography>
                        )}

                        {/* URL */}
                        {other.entryTags.url && (
                            <Typography variant="body2">
                                <Link href={other.entryTags.url} target="_blank" rel="noopener noreferrer">
                                    External Link
                                </Link>
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            ))}
        </Container>
    );
}

export default Other;
